import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../RootState';
import {
    assignVipByEmail,
    createTeam,
    getSnapshot,
    saveSellerConfig,
    saveVipOverride,
    updateTeam,
} from './api';
import {
    PanelSnapshot,
    SellerConfigPatch,
    TeamCreatePayload,
    TeamUpdatePatch,
    VipAssignByEmailPayload,
    VipOverridePatch,
} from './panel_comerciales.types';

export const loadSnapshot = createAsyncThunk<
    PanelSnapshot,
    void | { period?: string },
    { state: RootState }
>('panel_comerciales/loadSnapshot', async (payload, thunkAPI) => {
    const token = thunkAPI.getState().User?.token ?? '';
    const period = (payload as { period?: string } | undefined)?.period;
    return getSnapshot(token, period);
});

export const saveSellerConfigThunk = createAsyncThunk<
    void,
    { sellerId: number; patch: SellerConfigPatch },
    { state: RootState }
>('panel_comerciales/saveSellerConfig', async ({ sellerId, patch }, thunkAPI) => {
    const token = thunkAPI.getState().User?.token ?? '';
    await saveSellerConfig(token, sellerId, patch);
    thunkAPI.dispatch(loadSnapshot());
});

export const saveVipOverrideThunk = createAsyncThunk<
    void,
    { clientId: string; patch: VipOverridePatch },
    { state: RootState }
>('panel_comerciales/saveVipOverride', async ({ clientId, patch }, thunkAPI) => {
    const token = thunkAPI.getState().User?.token ?? '';
    await saveVipOverride(token, clientId, patch);
    thunkAPI.dispatch(loadSnapshot());
});

export const assignVipByEmailThunk = createAsyncThunk<
    void,
    { payload: VipAssignByEmailPayload },
    { state: RootState }
>('panel_comerciales/assignVipByEmail', async ({ payload }, thunkAPI) => {
    const token = thunkAPI.getState().User?.token ?? '';
    await assignVipByEmail(token, payload);
    thunkAPI.dispatch(loadSnapshot());
});

export const createTeamThunk = createAsyncThunk<
    void,
    { payload: TeamCreatePayload },
    { state: RootState }
>('panel_comerciales/createTeam', async ({ payload }, thunkAPI) => {
    const token = thunkAPI.getState().User?.token ?? '';
    await createTeam(token, payload);
    thunkAPI.dispatch(loadSnapshot());
});

export const updateTeamThunk = createAsyncThunk<
    void,
    { teamId: number; patch: TeamUpdatePatch },
    { state: RootState }
>('panel_comerciales/updateTeam', async ({ teamId, patch }, thunkAPI) => {
    const token = thunkAPI.getState().User?.token ?? '';
    await updateTeam(token, teamId, patch);
    thunkAPI.dispatch(loadSnapshot());
});
